var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_361493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.50022 16.3C8.17022 16.3 7.08911 15.2189 7.08911 13.8889V10.7777H5.61133V13.8889C5.61133 16.0355 7.35355 17.7777 9.50022 17.7777C11.6469 17.7777 13.3891 16.0355 13.3891 13.8889V10.7777H11.9113V13.8889C11.9113 15.2189 10.8302 16.3 9.50022 16.3ZM10.278 13.1111V6.88885H8.72244V13.1111H10.278ZM5.61133 6.11107V9.22219H7.08911L7.08911 6.11107C7.08911 4.78107 8.17022 3.69996 9.50022 3.69996C10.8302 3.69996 11.9113 4.78107 11.9113 6.11107V9.22219H13.3891V6.11107C13.3891 3.96441 11.6469 2.22219 9.50022 2.22219C7.35355 2.22219 5.61133 3.96441 5.61133 6.11107Z",
    fill: "#171A1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1084_361493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 18.6667,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.166992 19.3333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertLink);
export default __webpack_public_path__ + "static/media/insert-link.559411d7f56758fb69427d92c07a35b4.svg";
export { ForwardRef as ReactComponent };